import { Theme } from '@mui/material';
import styled from '@emotion/styled';
import ButtonMui from '@mui/material/Button';

type ParamsStyle = {
    theme?: Theme;
    handlebutton: string;
}

export const ContentCard = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
        width: 100%;
        display: grid;
        border-radius: 7px;
        border: 1px solid #008DD2;
        padding: 1.48rem 1.125rem;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            max-width: 14rem;
            padding: 1.25rem 1rem 1.625rem;
        }
`);

export const RiskGreen = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
        display: flex;
        margin: .5rem 0;
        align-items: end;

        div {
            width: 3.31rem;
            height: .2rem;
            background-color: ${theme?.palette.secondary.main};
        }

        span {
            height: 1px;
            width: 7.8rem;
            display: block;
            background-color: #ECECEC;
        }
`);

export const ContentList = styled('ul')(
    ({ theme }: { theme?: Theme; }) => `
        display: flex;
        gap: 0 2rem;
        min-height: 3.6rem;
        flex-wrap: wrap;
        flex-direction: row;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            gap: 0;
            min-height: 9.5rem;
            flex-wrap: nowrap;
            flex-direction: column;
        }
`);

export const ContentPrice = styled('div')(
    ({ theme }: { theme?: Theme; }) => `
        width: 100%;
        display: flex;
        margin-top: 1rem;
        text-align: center;
        align-items: center;
        flex-direction: row;
        justify-content: space-between;

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            margin-top: .5rem;
            flex-direction: column;
            justify-content: center;

            h4 {
                font-size: 2.1rem;
            }

            p {
                font-size: .75rem;
            }
        }
`);

export const Button = styled(ButtonMui)(
    ({ theme, handlebutton }: ParamsStyle) => `
        height: 2.81rem;
        font-size: 1rem;
        margin-top: 0;
        font-weight: bolder;
        max-width: 7.375rem;
        background-color: ${handlebutton === 'add' ? theme?.palette.primary.main : theme?.palette.primary.light};
        
        :hover {
            background-color: ${handlebutton === 'add' ? theme?.palette.primary.main : theme?.palette.primary.light};
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            max-width: 11.625rem;
            margin-top: 1.5rem;
        }
`);